
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campanhas/nao-compre-carro-sem-antes-consultar-o-historico",
      function () {
        return require("private-next-pages/campanhas/nao-compre-carro-sem-antes-consultar-o-historico/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campanhas/nao-compre-carro-sem-antes-consultar-o-historico"])
      });
    }
  